import { JOB_LIST } from '../../Constants/JobConstant'

const jobReducer = (state = false, action: { type: any; data: any; }) => {
  switch (action.type) {
    case JOB_LIST:
      return action.data
    default:
      return state
  }
}

export default jobReducer
